import * as React from 'react';
import classnames from "classnames";
import { Typeahead } from 'react-bootstrap-typeahead';
require('react-bootstrap-typeahead/css/Typeahead.css');
const styles = require('./NewVehicle.local.css');

import { ServiceAccount } from '../../../../../models/ServiceAccount';
import { IdName } from '../../../../../models/IdName';

import { Select } from '../../../../../components/Select'
import { intToString, stringToInt } from '../../../../../converters/converters'

import { EditVehicleActions, EditVehicleState } from "../flux";
import { Timezone } from "../../../../../rest/Misc/timezones";
import { TimezoneStoreState } from "../../../../utils/TimeZone/TimeZoneStore";
import { FormItemHorizontal } from "../../../Forms/FormItemHorizontal";
import { SourceSelector } from "./SourceSelector";
import { Source } from "../../../../../models/Vehicle";
import { AddTags } from "../../../AddTags";
import { DivisionSelector } from "../../../DivisionSelector";
import { Division } from "../../../../../models";
import { Polyglot } from '../../../../../polyglot';
import { LabelGroup, LoadableGroup, InputTextGroup } from "../../../Forms/Groups";
import { NonIsolatedPremise } from "../../../NonIsolatedPremise";
import { TypeaheadEnterEscWrapper } from '../../../TypeaheadEnterEscWrapper';

const getServiceAccountValue = (account: ServiceAccount) => intToString(account.id);
const getServiceAccoutDisplay = (account: ServiceAccount) => account.Username;
const getGeotabValue = (pair: IdName) => pair.Id;
const getGeotabDisplay = (pair: IdName) => pair.Name;
const getTimezoneDisplay = (tz: Timezone) => tz.Display;

interface FormsProps
{
    polyglot: Polyglot;
    
    loadingDivisions: boolean;
    loadingServiceAccounts: boolean;
    loadingVehicles: boolean;

    onDivisionChanged: (division: Division) => void;
    onServiceAccountChanged: (serviceAccountId: number) => void;
    onVehicleChanged: (vehicle: IdName) => void;
}

type Props = Partial<EditVehicleState> & Partial<TimezoneStoreState> & Partial<EditVehicleActions> & FormsProps;
export class NewVehicle extends React.Component<Props>
{
    render()
    {
        const {
            polyglot,
            draft, mode,
            setSource,
            setBoxId,
            setDisplay,
            setTags,
            setTimezone,
        } = this.props;

        const selectedGeotab = getSelectedValue(this.props.vehicles || [], draft.GeotabId);
        const selectedTz = getSelectedValue(this.props.timezones || [], draft.TimezoneId);
        const selectedTzTitle = selectedTz.length ? selectedTz[0].Display : '';

        return (
            <div className={classnames("form-horizontal", styles.NewVehicle)}>
                <NonIsolatedPremise>
                { mode === 'create' &&
                    <SourceSelector
                        polyglot={polyglot}
                        active={draft.SourceId - 1}
                        onGeotabClicked={() => setSource(Source.Geotab) }
                        onBoxIdClicked={() => setSource(Source.BoxId)} />
                }
                </NonIsolatedPremise>
                <NonIsolatedPremise>
                { mode === 'edit' &&
                    <LabelGroup title={polyglot.t('vehicle.label_source') + ':'} value={draft.SourceId === Source.Geotab ? 'Geotab' : 'Box ID'} />
                }
                </NonIsolatedPremise>
                <div>
                    <LoadableGroup title={polyglot.t('vehicle.label_division') + ':'} value={draft.Division} isLoading={this.props.loadingDivisions}>
                        <DivisionSelector divisions={this.props.allDivisions || []} onChange={this.props.onDivisionChanged} selectedId={draft.DivisionId} />
                    </LoadableGroup>
                    { draft.SourceId === Source.BoxId &&
                        <InputTextGroup title={polyglot.t('vehicle.label_box_id') + ':'} value={draft.BoxId || ''} onChange={e => setBoxId(e.target.value)} />
                    }
                    <NonIsolatedPremise>
                        { draft.SourceId == Source.BoxId && <div className='form-group' style={{height: 34}} /> }
                    </NonIsolatedPremise>
                    { draft.SourceId === Source.Geotab &&
                        <LoadableGroup title={polyglot.t('vehicle.label_service_account') + ':'} value={draft.ServiceAccount} isLoading={this.props.loadingServiceAccounts}>
                            <Select className='form-control'
                                placeholder='---'
                                items={this.props.filteredServiceAccounts || []}
                                defaultValue={intToString(draft.ServiceAccountId)}
                                valueFn={getServiceAccountValue}
                                titleFn={getServiceAccoutDisplay}
                                onChange={s => {
                                    const service_account = stringToInt(s.getValue());
                                    this.props.onServiceAccountChanged(service_account);
                                }} />
                        </LoadableGroup>
                    }
                    { draft.SourceId === Source.Geotab &&
                        <LoadableGroup title={polyglot.t('vehicle.label_vehicle') + ':'} value={draft.GeotabTitle} isLoading={this.props.loadingVehicles}>
                            <TypeaheadEnterEscWrapper>
                                <Typeahead labelKey={getGeotabDisplay} options={this.props.vehicles || []}  selected={selectedGeotab}
                                    onChange={(values: IdName[]) => this.props.onVehicleChanged((values && values.length > 0) ? values[0] : null)}
                                    placeholder={polyglot.t('vehicle.placeholder_vehicle')} />
                            </TypeaheadEnterEscWrapper>
                        </LoadableGroup>
                    }
                    <LoadableGroup title={polyglot.t('vehicle.label_timezone') + ':'} value={selectedTzTitle} isLoading={false}>
                        <TypeaheadEnterEscWrapper>
                            <Typeahead labelKey={getTimezoneDisplay} options={this.props.timezones}  selected={selectedTz}
                                onChange={(tz: Timezone[]) => setTimezone((tz && tz.length) ? tz[0].Id : null)}
                                placeholder={polyglot.t('vehicle.placeholder_timezone')} />
                        </TypeaheadEnterEscWrapper>
                    </LoadableGroup>
                    <InputTextGroup title={polyglot.t('vehicle.label_display') + ':'} value={draft.Display} onChange={e => setDisplay(e.target.value)} />
                    <FormItemHorizontal title={polyglot.t('vehicle.label_tags') + ':'} labelColumns={4}>
                        <AddTags
                            placeholder={polyglot.t('vehicle.placeholder_tags')}
                            newSelectionPrefix={polyglot.t('vehicle.prefix_for_tags') + ': '}
                            selected={draft.Tags} options={this.props.allTags} onChange={setTags} />
                    </FormItemHorizontal>
                </div>
            </div>
        );
    }
}

function getSelectedValue<K, T extends { Id: K }>(items: T[], id: K)
{
    const found = items.find(item => item.Id === id);
    return found === undefined ? [] : [found];
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/NewVehicle/index.tsx